import { ExprValue } from '../ExprValue';
export var EvalOper;
(function (EvalOper) {
    function not(operand) {
        if (operand === null) {
            return null;
        }
        else {
            return ExprValue.not(operand);
        }
    }
    EvalOper.not = not;
    function neg(operand) {
        return ExprValue.negate(operand);
    }
    EvalOper.neg = neg;
    function logical(operator, left, right) {
        switch (operator) {
            case 'OR':
                return ExprValue.or(left, right);
            case 'AND':
                return ExprValue.and(left, right);
        }
    }
    EvalOper.logical = logical;
    function mathematic(operator, left, right) {
        if (typeof left === 'number') {
            if (typeof right === 'number') {
                return arithmetic(operator, left, right);
            }
            else {
                return arithmetic(operator, left, ExprValue.asDecimal(right));
            }
        }
        else if (typeof right === 'number') {
            return arithmetic(operator, ExprValue.asDecimal(left), right);
        }
        else {
            return arithmetic(operator, ExprValue.asDecimal(left), ExprValue.asDecimal(right));
        }
    }
    EvalOper.mathematic = mathematic;
    function relational(operator, left, right) {
        switch (operator) {
            case '=':
                return ExprValue.eq(left, right);
            case '<>':
                return ExprValue.neq(left, right);
            case '<':
                return ExprValue.lt(left, right);
            case '<=':
                return ExprValue.lte(left, right);
            case '>':
                return ExprValue.gt(left, right);
            case '>=':
                return ExprValue.gte(left, right);
        }
    }
    EvalOper.relational = relational;
    function identity(operator, left, right) {
        switch (operator) {
            case 'IS':
            case 'IS NOT DISTINCT FROM':
                return ExprValue.is(left, right);
            case 'IS NOT':
            case 'IS DISTINCT FROM':
                return !ExprValue.is(left, right);
        }
    }
    EvalOper.identity = identity;
    function arithmetic(operator, left, right) {
        switch (operator) {
            case '+':
                return ExprValue.add(left, right);
            case '-':
                return ExprValue.sub(left, right);
            case '*':
                return ExprValue.mul(left, right);
            case '/':
                return ExprValue.div(left, right);
            case '%':
                return ExprValue.mod(left, right);
        }
    }
})(EvalOper || (EvalOper = {}));
